import { UtilsService } from './utils.service';
import { ToastrService } from 'ngx-toastr';
import { Denounce } from './../models/denounce.model';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';

import { SSE } from 'sse.js';
import { BehaviorSubject, Observable } from 'rxjs';
interface SseEvent extends Event {
	event: string;
	data: any;
}

@Injectable({
	providedIn: 'root',
})
export class SseService {
	constructor(
		private authService: AuthService,
		private toastr: ToastrService,
		private utils: UtilsService
	) {}

	private sse_inputs_subject = new BehaviorSubject<Denounce[]>([]);
	private sse_instance: SSE;

	private newMessages = 0;

	// private interval = setInterval(() => {
	// 	let message;

	// 	if (this.authService.isAuthenticated) {
	// 		if (this.newMessages > 0) {
	// 			message = `Foram recebidas ${this.newMessages} denúncias nos no Terminal últimos 5 minutos.`;
	// 			this.toastr.error(message);
	// 		} else if (this.newMessages === 1) {
	// 			message = `Foi recebida ${this.newMessages} denúncia no Terminal nos últimos 5 minutos.`;
	// 			this.toastr.error(message);
	// 		}

	// 		this.newMessages = 0;
	// 	}
	// }, 30 * 1000);

	get list$(): Observable<Denounce[]> {
		if (this.sse_instance) {
			return this.sse_inputs_subject.asObservable();
		} else {
			this.getSse();
			return this.sse_inputs_subject.asObservable();
		}
	}

	set list(value: Denounce[]) {
		this.sse_inputs_subject.next(value);
	}

	public get sse(): SSE {
		return this.sse_instance;
	}

	public getSse(): SSE {
		let superUser = Boolean(localStorage.getItem('superUser'));

		const base_url = 'https://sse.ninamob.com/stream?';

		// Uncomment for Local url
		// const base_url = 'http://localhost:8000/stream?';

		const complement_user = `user=${superUser ? 'super' : 'b2g'}`;

		const complement_channel = `&channel=${
			superUser ? 'super' : this.authService.userLocale
		}`;

		// Channel and user have different answers for different type of users

		const complement_authorization = `&authorization=${this.authService.idToken}`;

		const url =
			base_url +
			complement_user +
			complement_channel +
			complement_authorization;

		let sse = new SSE(url);

		sse.onopen = (event) => {};

		sse.onerror = (event: SseEvent) => {};

		sse.onmessage = (event: SseEvent) => {};

		sse.onclose = (event) => {};

		sse.addEventListener('complaint.created', (event) => {
			let denuncia = JSON.parse(event.data);
			const isWoman =
				denuncia.victim_details.gender == 'Mulher trans' ||
				denuncia.victim_details.gender == 'Mulher cis';
			if (denuncia.at_moment === true && isWoman) {
				this.newMessages++;
			}
			this.list = [denuncia, ...this.sse_inputs_subject.value];
		});

		this.sse_instance = sse;

		this.sse_instance.stream();

		return sse;
	}

	public closeSse(sse: EventSource): void {
		sse.close();
	}

	public getSseMessage(sse: EventSource): Promise<any> {
		return new Promise((resolve, reject) => {
			sse.addEventListener('message', (event) => {
				resolve(event.data);
			});
		});
	}

	public getSseError(sse: EventSource): Promise<any> {
		return new Promise((resolve, reject) => {
			sse.addEventListener('error', (event: SseEvent) => {
				resolve(event.data);
			});
		});
	}
}
